/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdnSelectModule} from '../common/directives/adn-select/adn-select.module';
import {AdminListModule} from '../common/directives/admin-list.module';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {BlocklistEditPageComponent} from './blocklist-edit-page.component';
import {BlocklistEditUsageComponent} from './blocklist-edit-usage.component';
import {BlocklistListPageComponent} from './blocklist-list-page.component';
import {BlocklistRoutePageComponent} from './blocklist-route-page.component';

const BLOCKLIST = [
  BlocklistEditPageComponent,
  BlocklistEditUsageComponent,
  BlocklistListPageComponent,
  BlocklistRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdnSelectModule,
    AdminListModule,
    FormControlsModule
  ],
  declarations: BLOCKLIST,
  exports: BLOCKLIST
})
export class BlocklistModule {
}
